module.exports = __webpack_public_path__ + "8639252ffc028184dbdb77f0ead95afb.png";